
import { defineComponent, PropType } from "vue";
import { useComputedFn, formatUtcDate } from "@/core/directive/function/common";
import { KycType, KycDisplayStatus } from "@/core/directive/type/kyc";
import { getKycDisplayStatus } from "@/core/directive/function/kyc";
import { ContactInfo, ContactInfoData } from "@/core/directive/interface/kyc";

export default defineComponent({
  props: {
    type: {
      type: String as PropType<KycType>,
      default: KycType.Juridical,
    },
    data: {
      type: Object as PropType<ContactInfo>,
      default: ContactInfoData,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    /**
     * @description: 渲染：状态
     */
    const getStatus = useComputedFn(getKycDisplayStatus);
    return {
      KycType,
      KycDisplayStatus,
      formatUtcDate,
      getStatus,
    };
  },
});
